import {IEntryCategory} from "./Category";

export enum EntryType {
    ARTICLE = 1,
    BIG_DATA_NEWS = 3,
    PRESS_INFORMATION = 4,
    PRESS_REVIEW = 5
}

export enum ContentItemType {
    TEXT = "text",
    IMAGE = "image",
    LINK = "link",
    BLOCKQUOTE = "blockquote",
    VIMEO = "vimeo",
    YOUTUBE = "youtube",
    SPOTIFY = "spotify",
    X = "x",
    LINKEDIN = "linkedin",
    GALLERY = "gallery"
}

export interface ContentEmbedValue {
    url: string;
    embed_url: string;
}

export interface ContentXValue {
    url: string;
    html: string;
}

interface ContentItemText {
    type: ContentItemType.TEXT;
    value: string;
}

export interface ContentImageValue {
    title: string;
    description: string;
    html: string;
}

interface ContentItemImage {
    type: ContentItemType.IMAGE;
    /** CMS oddaje dziś obiekt z opisem, ale starsze środowiska wciąż zwracają samo `html` jako string. */
    value: string | ContentImageValue;
}

export interface IGalleryImage {
    title: string;
    images: {
        img_840x523: string;
        img_744x463: string;
        img_430x268: string;
        g_img_1280?: string;
        g_img_1500x844?: string;
        g_img_1500?: string;
    };
}

interface ContentItemGallery {
    type: ContentItemType.GALLERY;
    value: IGalleryImage[];
}

interface ContentItemBlockquote {
    type: ContentItemType.BLOCKQUOTE;
    value: {
        text: string;
        header: string;
        cite: string;
    };
}

interface ContentItemLink {
    type: ContentItemType.LINK;
    value: {
        text: string;
        title: string;
        url: string;
        blank: boolean;
    };
}

interface ContentItemEmbed {
    type: ContentItemType.VIMEO | ContentItemType.YOUTUBE | ContentItemType.SPOTIFY;
    value: ContentEmbedValue;
}

interface ContentItemX {
    type: ContentItemType.X;
    value: ContentXValue;
}

interface ContentItemLinkedin {
    type: ContentItemType.LINKEDIN;
    value: ContentXValue;
}

export type ContentItem =
    | ContentItemText
    | ContentItemImage
    | ContentItemBlockquote
    | ContentItemLink
    | ContentItemEmbed
    | ContentItemX
    | ContentItemLinkedin
    | ContentItemGallery;

export type EntryVisibility = "public" | "paid_only" | "members_only";

export interface IEntry {
    author: string | null;
    is_highlighted: boolean;
    highlighted_type: number | null;
    is_video_material: boolean;
    category: Array<IEntryCategory> | null;
    content: Array<ContentItem> | null;
    id: number;
    image: string | null;
    images: {
        img_1916x1410?: string;
        img_1367x573: string;
        img_840x523: string;
        img_744x463: string;
        img_430x268: string;
        img_426x466?: string;
        img_385x193: string;
        img_332x208: string;
        img_320x256?: string;
        img_600x300: string;
    } | null;
    lead: string | null;
    publication_date: string;
    region: string | null;
    region_name: string | null;
    slug: string;
    source: string | null;
    tags: Array<IEntryCategory> | null;
    title: string;
    type: EntryType;
    visibility?: EntryVisibility;
}
